var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Active)?_c('div',{staticClass:"c-box c-tabs__tab-content"},[_vm._t("default",null,{"active":_vm.Active})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }